import {createFileRoute} from '@tanstack/react-router';
import {StatementPaymentCancelCallbackPage} from 'features/statement-payment/pages/StatementPaymentCancelCallbackPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/cancel/callback',
)({
  component: StatementPaymentCancelCallbackPage,
  validateSearch: (search) => {
    return {
      status: search.status as string | undefined,
    };
  },
});
